<script>
    import AudioItem from "../../components/audio-player/AudioItem.svelte";

    import HeaderBar from "../../../../components/header/HeaderBar.svelte";
    import { push } from "svelte-spa-router";
    import { getEntities, getEntity } from "../../../../api-client";
    import AudioGuideCodeEntry from "./AudioGuideCodeEntry.svelte";
    import AudioGuideGuard from "../../guards/AudioGuideGuard.svelte";
    import LoadingSquare from "../../../../common/LoadingSquare.svelte";
    import { _ } from "svelte-i18n";

    export let params = {};
    $: if (params.id) {
        window.scrollTo(0, 0);
    }
    $: guideId = params.id;

    $: slideOpen = false;

    $: guide = Promise.all([
        getEntity("audio_guide", guideId),
        getEntities("guide_track"),
    ]).then(([guide, tracks]) => {
        if (guide && tracks) {
            guide.tracks = tracks.filter((track) =>
                guide.fk_tracks?.includes(track.id)
            );
            return guide;
        }
    });

    function showCodeEntry() {
        slideOpen = true;
    }
</script>

{#await guide}
    <LoadingSquare />
{:then guide}
    <AudioGuideGuard audioGuide={guide} />
    <HeaderBar
        on:actionClicked={() => showCodeEntry()}
        flexHeader
        code
        title={guide.title}
        onSite
    />
    <div class="padding">
        <div class="headline-xs">{guide.title}</div>
        <div style="margin-top: 4px; margin-bottom:44px" class="headline-m">
            AudioGuide
        </div>
        {#each guide.tracks as track, index}
            <AudioItem
                audioGuide={track}
                on:click={() => push(`/audio-guide/${guideId}/${track.id}`)}
            />
            {#if index < guide.tracks.length - 1}
                <div
                    style="margin-top: 16px; margin-bottom: 16px;"
                    class="divider-h"
                />
            {/if}
        {/each}
    </div>

    {#if slideOpen}
        <div style="background-color: var(--white-100); ">
            <div class="slider bg-blur-m">
                <AudioGuideCodeEntry
                    {guide}
                    on:close={() => (slideOpen = false)}
                />
            </div>
        </div>
    {/if}
{/await}

<style>
    .padding {
        padding: 16px;
    }

    .slider {
        position: fixed;
        z-index: 4;
        height: 100%;
        width: 100%;
        top: 0px;
        -webkit-backdrop-filter: blur(24px);
        backdrop-filter: blur(24px);
        background: var(--white-64);
    }

    @media only screen and (min-width: 1440px) {
        .padding {
            padding: 116px 40px 40px 40px;
        }
    }
</style>
